import queryString from '@framework/utils/queryString';

const getTasksDecisionsHandler =
    (isAdminSection: boolean) =>
    (
        roomSlug: string,
        {
            id,
            type,
            mode
        }: {
            id?: string;
            type?: 'task' | 'decision';
            mode?: string;
        } = {}
    ): string => {
        const params = queryString.stringify({
            filter_ids: id,
            filter_type: type,
            filter_mode: mode
        });
        return `${isAdminSection ? '/administrator' : ''}/rooms/${roomSlug}/tasks-and-decisions/${params ? `?${params}` : ''}`;
    };

export const attendee = {
    tasksDecisions: getTasksDecisionsHandler(false)
};

export const admin = {
    tasksDecisions: getTasksDecisionsHandler(true)
};

export const api = {
    loadAttachableTasks: (agendaItemId: string): string =>
        `/api/events/minutes/tasks/attached/attachable/${agendaItemId}/`,
    loadAttachedTasks: (agendaItemId: string): string =>
        `/api/events/minutes/tasks/attached/agenda/${agendaItemId}/`,
    loadTasksAttachedToMeeting: (meetingId: string): string =>
        `/api/events/minutes/tasks/attached/meeting/${meetingId}/`,
    attachTask: (agendaItemId: string): string =>
        `/api/events/minutes/tasks/attached/agenda/${agendaItemId}/`,
    attachTasks: (agendaItemId: string): string =>
        `/api/events/minutes/tasks/attached/agenda/${agendaItemId}/bulk/`,
    detachTask: (agendaItemId: string, taskId: string): string =>
        `/api/events/minutes/tasks/attached/agenda/${agendaItemId}/${taskId}/`,
    loadAttachableTasksAssignees: (agendaItemId: string): string =>
        `/api/events/minutes/tasks/attached/attachable/${agendaItemId}/assignees/`,
    updateAttachedTask: (agendaItemId: string, taskId: string): string =>
        `/api/events/minutes/tasks/attached/agenda/${agendaItemId}/${taskId}/`,
    updateTaskAttached: (agendaItemId: string, taskId: string, mode: string): string =>
        `/api/events/minutes/tasks/attached/agenda/${agendaItemId}/${taskId}/?mode=${mode}`,
    loadTasksDecisions: (): string => `/api/events/assignable_minutes/`,
    loadAssignees: (): string => `/api/events/assignable_minutes/assignees/summary/`,
    loadOriginMeetings: (): string => `/api/events/assignable_minutes/origin_meetings/`,
    loadTasksDecisionsHistory: (type: string, id: string): string =>
        `/api/events/minutes/${type}s/${id}/history/`,
    downloadCsv: (): string => `/api/events/minutes/export/`,
    downloadTasksDecisions: (): string => `/api/events/minutes/export/`,
    loadDecisionStates: (roomId: string) =>
        `/api/events/minutes/decision_states/?room_id=${roomId}`,
    loadTaskStates: (roomId: string): string => `/api/events/minutes/task_states/?room_id=${roomId}`
};
